import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAccountPersonRequest, PaymentMethod } from 'src/app/models/PaymentModels';
import { NgForm } from '@angular/forms';
import { PaymentsService } from 'src/app/services/payments.service';
import { ToastrService } from 'ngx-toastr';
import { PhonePipe } from '../../../pipes/phone.pipe';
import * as moment from 'moment';
import { ChannelEvent, ChannelService } from 'src/app/services/channel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/users-module/services/user.service';
import { UserLight } from 'src/app/users-module/models/userLight';

@Component({
  selector: 'app-add-payment-method',
  templateUrl: './add-payment-method.component.html',
  styleUrls: ['./add-payment-method.component.less']
})
export class AddPaymentMethodComponent implements OnInit, OnDestroy {

  @Input() clientId: number;
  @Output() paymentMethodAddFlowComplete: EventEmitter<PaymentMethod> = new EventEmitter();
  @Output() paymentMethodAddFlowStarted: EventEmitter<any> = new EventEmitter();
  @ViewChild('addPmtForm', {}) ngForm: NgForm;
  cardNickName: string;
  private paymentAccount: CreateAccountPersonRequest;
  private paymentMethod: PaymentMethod;
  aptexxCreatePaymentLink: string;
  iframeLoadCalls: number = 0;
  currentStage: number = 0;
  public get model(): CreateAccountPersonRequest {
    if (!this.paymentAccount) return new CreateAccountPersonRequest();
    else return this.paymentAccount;
  }

  constructor(public payments: PaymentsService, private toast: ToastrService, private channels: ChannelService, public sanitizer: DomSanitizer, public auth : AuthService, public users : UserService) { }

  ngOnDestroy(): void {
    //this.payments._paymentMethodAddFlowStart.unsubscribe();
    console.log('add pmt component destroyed');
  }

  ngOnInit() {
    this.users.FetchUsersForClient(this.clientId);
    //SCRSTP-1555: disable pre-fetch of payment account provider because of the CRA case.
    this.paymentAccount = new CreateAccountPersonRequest();
    // this.payments.FetchPaymentProviderAccount().subscribe((res: CreateAccountPersonRequest) => {
    //   this.paymentAccount = res;
    // },
    //   err => {
    //     this.toast.error('Error fetching existing payment information!', '', { closeButton: true, disableTimeOut: true })
    //   })
    this.channels.sub('PaymentMethodAdded').subscribe((ev: ChannelEvent) => {
      this.paymentMethod = JSON.parse(ev.data);
      this.paymentMethod.nickName = this.cardNickName;
      this.payments.EditPaymentMethod(this.paymentMethod).subscribe(r => {
        this.toast.success('Payment method saved successfully.', '');
        this.payments.FetchPaymentMethods(0, this.clientId).subscribe((scc: PaymentMethod[]) => {
          this.payments._paymentMethods = scc;
          this.payments.processing = false;
          this.paymentMethodAddFlowComplete.next(this.paymentMethod);
        });
      },
        err => this.toast.error('There was an error editing your payment method!', '', { closeButton: true, disableTimeOut: true }));
      this.payments.processing = false;
    });
  }

  cancel(): void {
    this.payments.processing = false;
  }

  public get availableUsers() : UserLight[] {
    return this.users.users.filter(r => {return r.userName != null });
  }


  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '')
      return [intlCode,match[2], match[3],match[4]].join('')
    }
    return null
  }


  save(): void {
    if (!this.ngForm.valid) {
      this.toast.error('Validation errors exist.', '', { disableTimeOut: true, closeButton: true });
      return;
    }
    

    this.model.phone = this.formatPhoneNumber(this.model.phone);
    console.log(this.model);
    this.payments.SavePayer(this.model).subscribe((ev: ChannelEvent) => {
      let prsd = JSON.parse(ev.data);
      if (!prsd.link) {
        this.toast.error('There was an error trying to create your payment method', 'Error Connecting to Payment Provider', { closeButton: true, disableTimeOut: true });
      }
      this.aptexxCreatePaymentLink = prsd.link;
      this.payments.processing = true;

      this.currentStage++;
    }, (err: any) => {
      this.toast.error('Error Saving Payment Method', '', { disableTimeOut: true, closeButton: true });
    });
  }

  iframeLoaded() {
    if (this.iframeLoadCalls == 1) {
      this.paymentMethodAddFlowStarted.next();
    }
    this.payments.processing = false;
    this.iframeLoadCalls++;
    console.log('IFRAME LOAD COMPLETE', this.aptexxCreatePaymentLink);
  }

}
